import {BMTheme} from "../../../BMTheme";

export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  validationStyle: {
    color: BMTheme.formValidation.color,
    fontSize: "80%"
  },
  containerInput: {
    float: "left",
    marginRight: "2%"
  },

  dateInput: {
    textFieldStyle: {
      height: "72px"
    },
    customInputStyle: {
      paddingTop: 10
    }
  }
};

export const viewStyle = {
  textFieldStyle: {
    textTransform: "capitalize"
  },
  booleanFieldStyle: {
    margin: 0
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/style.js